

























import { Component, Mixins } from "vue-property-decorator";
import { NumberInput } from "../../../../../base/components/system";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";
import {
  IRangeOfMotionBehavior,
  ManualMuscleTestInputMethods,
  ManualMuscleTestPresentMethods,
} from "../../../../../documaker/domain/format/objects";

@Component({
  components: {
    NumberInput,
    OptionDropDownSelector,
  }
})
export default class RangeOfMotionBehaviorEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: IRangeOfMotionBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: IRangeOfMotionBehavior) => T, defaultValue: T) => T;

  get min(): number {
    return this.readPropertyOrDefault(s => s.range.min, null);
  }

  set min(value: number) {
    this.writePropertyWhenValid(s => s.range = { min: value, max: this.max });
  }

  get max(): number {
    return this.readPropertyOrDefault(s => s.range.max, null);
  }

  set max(value: number) {
    this.writePropertyWhenValid(s => s.range = { min: this.min, max: value });
  }

  get inputMethod(): ManualMuscleTestInputMethods {
    return this.readPropertyOrDefault(s => s.manualMuscleTestBahavior.inputMethod, ManualMuscleTestInputMethods.Keyboard);
  }

  set inputMethod(value: ManualMuscleTestInputMethods) {
    this.writePropertyWhenValid(s => s.manualMuscleTestBahavior = { inputMethod: value, presentMethod: this.presentMethod });
  }

  get presentMethod(): ManualMuscleTestPresentMethods {
    return this.readPropertyOrDefault(s => s.manualMuscleTestBahavior.presentMethod, ManualMuscleTestPresentMethods.Symbol);
  }

  set presentMethod(value: ManualMuscleTestPresentMethods) {
    this.writePropertyWhenValid(s => s.manualMuscleTestBahavior = { inputMethod: this.inputMethod, presentMethod: value });
  }

  correct(value: number): number {
    return value !== null ? Math.floor(value) : value;
  }

  inputMethodOptions: StandardOption<ManualMuscleTestInputMethods>[] = [
    new StandardOption<ManualMuscleTestInputMethods>("テンキー", ManualMuscleTestInputMethods.Keyboard),
    new StandardOption<ManualMuscleTestInputMethods>("クリック", ManualMuscleTestInputMethods.Click),
  ];

  presentMethodOptions: StandardOption<ManualMuscleTestPresentMethods>[] = [
    new StandardOption<ManualMuscleTestPresentMethods>("×、△、〇", ManualMuscleTestPresentMethods.Symbol),
    new StandardOption<ManualMuscleTestPresentMethods>("×、△、4、5", ManualMuscleTestPresentMethods.SymbolAndNumber),
    new StandardOption<ManualMuscleTestPresentMethods>("0、1、2、3、4、5", ManualMuscleTestPresentMethods.Number),
  ];
}
